import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './spinner-3-4-axis-milling/HeroSection';
import { SpecsSection } from './spinner-3-4-axis-milling/SpecsSection';
import { MachineModelsSection } from './spinner-3-4-axis-milling/MachineModelsSection';
export function Spinner3_4AxisMillingPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-3970">
      <SeoBar data-id="element-3971" />
      <Header data-id="element-3972" />
      <main className="flex-grow" data-id="element-3973">
        <div className="w-full bg-white pb-20" data-id="element-3974">
          <HeroSection data-id="element-3975" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-3976">
            <SpecsSection data-id="element-3977" />
            <MachineModelsSection data-id="element-3978" />
          </div>
        </div>
      </main>
      <Footer data-id="element-3979" />
    </div>;
}